"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var debugInit = function debugInit() {
  if (!/mdebug=true/.test(window.location.href)) return;
  var script = document.createElement('script');
  script.src = 'https://cdn.bootcss.com/eruda/1.2.6/eruda.min.js';
  script.async = true;
  document.querySelectorAll('head')[0].append(script);
  script.addEventListener('load', function () {
    eruda.init();
  });
};

var vconsoleInit = function vconsoleInit() {
  var whiteList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var arr = ['m-seller-astable.bingex.com', 'm-seller-bstable.bingex.com', 'm-seller-cstable.bingex.com', 'm-astable.bingex.com', 'm-bstable.bingex.com', 'm-cstable.bingex.com', 'fat.bingex.com', '10.2.16.109', '10.2.23.228', '10.2.16.247', '10.2.23.162', '10.2.16.82', '10.2.16.195', 'localhost', '0.0.0.0'].concat((0, _toConsumableArray2["default"])(whiteList));
  var newScript = document.createElement('script');

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;

      if (window.location.hostname === element || window.location.hostname.includes('m-stable')) {
        newScript.setAttribute('src', 'https://cdn.ishansong.com/ishansong-fe-courier/courierView/static/plugin/vconsole.js');
        newScript.async = true;
        document.body.append(newScript);
        newScript.addEventListener('load', function () {
          return new window.VConsole();
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var _default = {
  vconsoleInit: vconsoleInit,
  debugInit: debugInit
};
exports["default"] = _default;